const CACHE_KEY = "usb-portal-message-cache";
const defaultCache = { studentHold: null, classSelection: null };

let inMemoryCache = null;

const hasWindow = typeof window !== "undefined";

const readCacheFromStorage = () => {
  if (!hasWindow) {
    return { ...defaultCache };
  }

  try {
    const storedValue = window.sessionStorage.getItem(CACHE_KEY);
    if (storedValue) {
      const parsed = JSON.parse(storedValue);
      return { ...defaultCache, ...parsed };
    }
  } catch (error) {
    // If sessionStorage is unavailable, fall back to memory cache only.
  }

  return { ...defaultCache };
};

const persistCache = () => {
  if (!hasWindow || !inMemoryCache) {
    return;
  }

  try {
    window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(inMemoryCache));
  } catch (error) {
    // Ignore storage errors (private browsing, etc.).
  }
};

const getCache = () => {
  if (inMemoryCache) {
    return inMemoryCache;
  }
  inMemoryCache = readCacheFromStorage();
  return inMemoryCache;
};

export const getPortalMessageCacheSection = (section) => getCache()[section];

export const setPortalMessageCacheSection = (section, payload) => {
  const cache = getCache();
  inMemoryCache = { ...cache, [section]: payload };
  persistCache();
  return inMemoryCache[section];
};

export const clearPortalMessageCache = () => {
  inMemoryCache = { ...defaultCache };
  if (!hasWindow) {
    return;
  }

  try {
    window.sessionStorage.removeItem(CACHE_KEY);
  } catch (error) {
    // Ignore storage errors.
  }
};

